import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Navbar from '../components/shared-menu/Navbar';
import { ErrorBoundary } from 'react-error-boundary';
import { AuthProvider } from '../services/auth/AuthContext';

function GlobalErrorFallback({ error, resetErrorBoundary }) {
  const location = useLocation();
  const prevLocationRef = useRef(location.pathname);

  const handleReset = () => {
    resetErrorBoundary();
  };

  useEffect(() => {
    if (prevLocationRef.current === location.pathname) {
      return;
    }

    // Reset the error boundary when the location changes
    resetErrorBoundary();
  }, [location, resetErrorBoundary]);

  return (
      <>

        <ErrorBoundary fallback={null}>
          <AuthProvider>
            <Navbar />
          </AuthProvider>
        </ErrorBoundary>
        <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" height="100vh">
          <Paper elevation={0} sx={{ p: 4, minWidth: 320, textAlign: 'center' }}>
            <ErrorOutlineIcon sx={{ fontSize: 48, color: 'red', mb: 2 }} />
            <Typography color="error" variant="h6" gutterBottom>
              Something went wrong
            </Typography>
            <Button
              variant="contained"
              sx={{ backgroundColor: 'red', color: '#fff', '&:hover': { backgroundColor: '#b71c1c' } }}
              startIcon={<RefreshIcon />}
              onClick={handleReset}
            >
              Retry
            </Button>
          </Paper>
        </Box>
  
      </>
    );
}

export default GlobalErrorFallback;